import React, { useState, useEffect } from "react";
import { usuariosAPI, toolsAPI } from "../../utils/funcionesAPI";
//import Link from 'valuelink'
//import {isRequired, isEmail } from 'valuelink/tags'
//import FormInput from '../Global/FormInput.js'
import { Link } from "react-router-dom";
import {
  getLocalidadesPorPartido,
  getPartidosPorProvincia,
  manejadorDeRespuesta,
  validateCUITorCUIL,
} from "../../utils/Tools";
import { toast, ToastContainer } from "react-toastify";
import LoaderFormal from "../Global/LoaderFormal";
//import cuenta from '../../imagenes/datos/cuenta.jpg'
//import cuenta2x from '../../imagenes/datos/cuenta@2x.jpg'

const Registrar = (props) => {
  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [nacionalidades, setNacionalidades] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [partidos, setPartidos] = useState([]);
  const [localidades, setLocalidades] = useState([]);
  const [categoriasIVA, setCategoriasIVA] = useState([]);
  const [mostrarInputsOcultos, setMostrarInputsOcultos] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [usuario, setUsuario] = useState({
    email: "",
    password: "",
    nombre: "",
    apellido: "",
    tipoCliente: "IND",
    cliente: {
      nombreAgencia: "",
      tipoDocumento: { idTipoDocumento: 1, sigla: "DNI" },
      numeroDocumento: "",
      sexo: "M",
      nacionalidad: { codigo: "ARG" },
      telefono: "",
      celular: "",
      fechaNacimiento: "",
      pais: { codigo: "ARG" },
      provincia: { codigo: "0" },
      direccion: "",
      numeroCalle: "",
      codigoPostal: "",
      partido: { id: "0" },
      localidad: { id: "0" },
      categoriaIVA: { id: 5, codigo: "CFI", denominacion: "Consumidor Final" },
      legajo: "",
      mail: "ejemplo@mail.com",
    },
  });
  const [disabledCombosProvPartLoc, setDisabledCombosProvPartLoc] = useState(
    usuario.cliente.pais.codigo !== "ARG" ? true : false
  );

  useEffect(() => {
    let data = JSON.stringify({ accion: "tiposDeDocumento" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setTiposDocumento(respuesta.data);
    });

    data = JSON.stringify({ accion: "paises" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setNacionalidades(respuesta.data);
    });

    data = JSON.stringify({ accion: "provincias" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) setProvincias(respuesta.data);
    });

    data = JSON.stringify({ accion: "categoriasIVA" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setCategoriasIVA(respuesta.data);
    });

    getPartidosPorProvincia("ARC", setPartidos);
  }, []);

  const handleRegistrarChange = (e) => {
    setUsuario((state) => ({
      ...state,
      [e.target.name]: e.target.value,
    }));
  };

  const handleTipoClienteChange = (e) => {
    if (e.target.value === "AGE") {
      // los campos quedarian todos, pero si ponen categoria iva responsable inscripto (RIN), por defecto deberia ser en tipo de documento CUIT (CUIT)
      //y en el ultimo campo en vez de decir Nº de DNI, diria Nº de cuit.
      setUsuario((state) => ({
        ...state,
        cliente: {
          ...state.cliente,
          tipoDocumento: { idTipoDocumento: "7", sigla: "CUIT" },
        },
      }));
      // si pone monotributo, deberia tener la opcion de cuil o cuit
    } else if (e.target.value === "SIN") {
      //si es sind donde dice nombre de la agencia, deberia decir nombre del sindicato/mutual, legajo no estaria, y el resto de los campos quedan como estan.
    } else if (e.target.value === "FRE") {
      // sacar nombre de la agencia, sacar nro de legajo y dejamos los ultimos 3 campos seteados en Monotributo, CUIL o CUIT y nro de cuil o cuit.
      setUsuario((state) => ({
        ...state,
        cliente: {
          ...state.cliente,
          categoriaIVA: { id: "6", codigo: "MON", denominacion: "MONOTRIBUTO" },
          tipoDocumento: { idTipoDocumento: "7", sigla: "CUIT" },
        },
      }));
    }

    setUsuario((state) => ({
      ...state,
      [e.target.name]: e.target.value,
    }));
  };

  const handleDatosClienteChange = (e) => {
    setUsuario((state) => ({
      ...state,
      cliente: {
        ...state.cliente,
        [e.target.name]: e.target.value,
      },
    }));
  };

  const handleTipoDocumentoChange = (e) => {
    const tipoDocumento = tiposDocumento.find(
      (tip) => tip.sigla === e.target.value
    );
    setUsuario((state) => ({
      ...state,
      cliente: {
        ...state.cliente,
        tipoDocumento,
      },
    }));
  };

  const handleCategoriaIvaChange = (e) => {
    const categoriaIVA = categoriasIVA.find(
      (cat) => cat.codigo === e.target.value
    );

    const isResponsableInscripto = categoriaIVA.codigo === "RIN";

    let tipoDocumento = usuario.cliente.tipoDocumento;
    if (isResponsableInscripto) {
      setIsDisabled(true);
      tipoDocumento = {
        idTipoDocumento: "7",
        sigla: "CUIT",
        denominacion: "CUIT",
      };
    } else {
      setIsDisabled(false);
    }

    setUsuario((state) => ({
      ...state,
      cliente: {
        ...state.cliente,
        categoriaIVA,
        tipoDocumento,
      },
    }));
  };

  const handlePaisChange = (e) => {
    const nacionalidad = nacionalidades.find(
      (nac) => nac.codigo === e.target.value
    ) || { codigo: "ARG" };

    if (nacionalidad.codigo !== "ARG") {
      setDisabledCombosProvPartLoc(true);
      //setProvincias([]);
      setPartidos([]);
      setLocalidades([]);
    } else {
      setDisabledCombosProvPartLoc(false);
    }

    setUsuario((state) => ({
      ...state,
      cliente: {
        ...state.cliente,
        nacionalidad,
        pais: nacionalidad,
      },
    }));
  };

  const handleProvinciaChange = (e) => {
    const provincia = provincias.find(
      (prov) => prov.codigo === e.target.value
    ) || { codigo: "0" };
    setUsuario((state) => ({
      ...state,
      cliente: {
        ...state.cliente,
        provincia,
        partido: { id: "0" },
        localidad: { id: "0" },
      },
    }));

    getPartidosPorProvincia(provincia.codigo, setPartidos);
  };

  const handlePartidoChange = (e) => {
    const partido = partidos.find((prov) => prov.codigo === e.target.value) || {
      codigo: "0",
    };
    setUsuario((state) => ({
      ...state,
      cliente: {
        ...state.cliente,
        partido,
        localidad: { id: "0" },
      },
    }));

    getLocalidadesPorPartido(partido.codigo, setLocalidades);
  };

  const handleLocalidadChange = (e) => {
    const localidad = localidades.find((loc) => loc.id === e.target.value) || {
      id: "0",
    };
    setUsuario((state) => ({
      ...state,
      cliente: {
        ...state.cliente,
        localidad,
      },
    }));
  };

  const handleMostrarInputsChange = (e) => {
    setMostrarInputsOcultos(e.target.checked);
    if (!e.target.checked) {
      //Si destilada el check vuelvo a poner el estado default
      setUsuario({
        email: "",
        password: "",
        nombre: "",
        apellido: "",
        tipoCliente: "IND",
        cliente: {
          nombreAgencia: "",
          tipoDocumento: { idTipoDocumento: 1, sigla: "DNI" },
          numeroDocumento: "",
          sexo: "M",
          nacionalidad: { codigo: "ARG" },
          telefono: "",
          celular: "",
          fechaNacimiento: "",
          pais: { codigo: "ARG" },
          provincia: { codigo: "ARC" },
          direccion: "",
          numeroCalle: "",
          codigoPostal: "",
          partido: { id: "0" },
          localidad: { id: "0" },
          categoriaIVA: {
            id: 5,
            codigo: "CFI",
            denominacion: "Consumidor Final",
          },
          legajo: "",
          mail: "ejemplo@mail.com",
        },
      });
    }
  };

  const validarCampos = (usuario) => {
    //if (usuario.tipoCliente === "IND") {

    if (
      usuario.email === "" ||
      usuario.password.trim() === "" ||
      usuario.nombre.trim() === "" ||
      usuario.apellido.trim() === "" ||
      (usuario.cliente.telefono === "" && usuario.cliente.celular === "") ||
      usuario.cliente.numeroDocumento === "" ||
      usuario.cliente.nacionalidad.codigo === "0" ||
      usuario.cliente.provincia.codigo === "0" ||
      usuario.cliente.partido.id === "0" ||
      usuario.cliente.localidad.id === "0" ||
      usuario.cliente.direccion === "" ||
      usuario.tipoCliente === ""
    ) {
      //usuario.tipoCliente = "IND";
      return false;
    }

    if (usuario.tipoCliente === "AGE") {
      if (
        usuario.cliente.nombreAgencia.trim() === "" ||
        usuario.cliente.categoriaIVA === "" ||
        usuario.cliente.legajo === ""
      ) {
        return false;
      }
    }

    if (usuario.tipoCliente === "SIN") {
      if (
        usuario.cliente.nombreAgencia.trim() === "" ||
        usuario.cliente.categoriaIVA === ""
      ) {
        return false;
      }
    }

    if (usuario.tipoCliente === "FRE") {
      if (usuario.cliente.categoriaIVA === "") {
        return false;
      }
    }

    if (
      usuario.cliente.tipoDocumento.sigla === "CUIT" ||
      usuario.cliente.tipoDocumento.sigla === "CUIL"
    ) {
      if (!validateCUITorCUIL(usuario.cliente.numeroDocumento)) {
        toast.info("El numero de CUIT/CUIL no es correcto", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        return false;
      }
    }

    return true;
  };

  const handleRegistrarClick = (e) => {
    e.preventDefault();

    if (usuario.password.length <= 3 || usuario.password.length > 8) {
      toast.info("La contraseña debe tener entre 4 y 8 caracteres", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    if (validarCampos(usuario)) {
      let data = JSON.stringify({
        accion: "registracionTemporal",
        usuario,
        canal: "WEB",
      });
      setLoaded(true);
      usuariosAPI(data).then((respuesta) => {
        setLoaded(false);
        if (manejadorDeRespuesta(props, respuesta)) {
          toast.success(respuesta.data, {
            position: toast.POSITION.BOTTOM_CENTER,
            onClose: () => props.history.push("/"),
          });
        }
      });
    } else {
      toast.info("Debe completar todos los campos", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  //const {usuario, tiposDocumento, nacionalidades, provincias, categoriasIVA  } = this.state;

  return (
    <section className="checkout-steps">
      <LoaderFormal loaded={loaded} />
      <div className="container">
        <div className="row">
          <div className="content col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div>
              <div className="title">
                <h2>Registrarse</h2>
                <p>* Todos los datos son obligatorios.</p>
                <hr />
              </div>
              <form className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="nombre">
                    Nombre *
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={usuario.nombre}
                    name="nombre"
                    placeholder="Nombre"
                    onChange={handleRegistrarChange}
                  />
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="apellido">
                    Apellido *
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={usuario.apellido}
                    name="apellido"
                    placeholder="Apellido"
                    onChange={handleRegistrarChange}
                  />
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="email">
                    Mail *
                  </label>
                  <input
                    className="form-control"
                    type="email"
                    name="email"
                    value={usuario.email}
                    id="mail"
                    placeholder="Ingrese su mail"
                    onChange={handleRegistrarChange}
                  />
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="tipoDocumento">
                    Tipo de Documento *
                  </label>
                  <select
                    className="form-control"
                    name="tipoDocumento"
                    onChange={handleTipoDocumentoChange}
                    value={usuario.cliente.tipoDocumento.sigla}
                  >
                    <option disabled value="">
                      Tipo Documento
                    </option>
                    {tiposDocumento.map((tipoDeDocumento) => {
                      return (
                        <option
                          key={tipoDeDocumento.idTipoDocumento}
                          value={tipoDeDocumento.sigla}
                        >
                          {tipoDeDocumento.denominacion}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="numeroDocumento">
                    N° {usuario.cliente.tipoDocumento.sigla} *
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="numeroDocumento"
                    placeholder="N° Documento"
                    onChange={handleDatosClienteChange}
                    value={usuario.cliente.numeroDocumento}
                  />
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="telefono">
                    Tel&eacute;fono *
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="telefono"
                    placeholder="Telefono"
                    onChange={handleDatosClienteChange}
                    value={usuario.cliente.telefono}
                  />
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="celular">
                    Celular *
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="celular"
                    placeholder="Celular"
                    onChange={handleDatosClienteChange}
                    value={usuario.cliente.celular}
                  />
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="direccion">
                    Calle *
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="direccion"
                    placeholder="Calle"
                    onChange={handleDatosClienteChange}
                    value={usuario.cliente.direccion}
                  />
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="direccion">
                    Nro *
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    name="numeroCalle"
                    placeholder="Nro"
                    onChange={handleDatosClienteChange}
                    value={usuario.cliente.numeroCalle}
                  />
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="direccion">
                    Cod. Postal *
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="codigoPostal"
                    placeholder="Cod. Postal"
                    onChange={handleDatosClienteChange}
                    value={usuario.cliente.codigoPostal}
                  />
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="nacionalidad">
                    Pais *
                  </label>
                  <select
                    className="form-control"
                    name="nacionalidad"
                    onChange={handlePaisChange}
                    value={usuario.cliente.nacionalidad.codigo}
                  >
                    <option value="0">Pais</option>
                    {nacionalidades.map((nacionalidad) => {
                      return (
                        <option
                          key={nacionalidad.id}
                          value={nacionalidad.codigo}
                        >
                          {nacionalidad.denominacion}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="provincia">
                    Provincia *
                  </label>
                  <select
                    className="form-control"
                    name="provincia"
                    onChange={handleProvinciaChange}
                    value={usuario.cliente.provincia.codigo}
                    disabled={disabledCombosProvPartLoc}
                  >
                    <option value="0">Provincia</option>
                    {provincias.map((provincia) => {
                      return (
                        <option key={provincia.id} value={provincia.codigo}>
                          {provincia.denominacion}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="partido">
                    Partido *
                  </label>
                  <select
                    className="form-control"
                    name="partido"
                    onChange={handlePartidoChange}
                    value={usuario.cliente.partido.id}
                    disabled={disabledCombosProvPartLoc}
                  >
                    <option value="0">Partido</option>
                    {partidos.map((partido) => {
                      return (
                        <option key={partido.id} value={partido.id}>
                          {partido.denominacion}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="localidad">
                    Localidad *
                  </label>
                  <select
                    className="form-control"
                    name="localidades"
                    onChange={handleLocalidadChange}
                    value={usuario.cliente.localidad.id}
                    disabled={disabledCombosProvPartLoc}
                  >
                    <option value="0">Localidad</option>
                    {localidades.map((localidad) => {
                      return (
                        <option key={localidad.id} value={localidad.id}>
                          {localidad.denominacion}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="password">
                    Password *
                  </label>
                  <input
                    className="form-control"
                    type="password"
                    name="password"
                    id="password"
                    onChange={handleRegistrarChange}
                    placeholder="Ingrese su contrase&ntilde;a (entre 4 y 8 caracteres)"
                  />
                </div>

                <div className="form-group d-inline-block text-center col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <input
                    className="checkRegistracion"
                    type="checkbox"
                    name="check"
                    checked={mostrarInputsOcultos}
                    onChange={handleMostrarInputsChange}
                  />
                  <label
                    className="labelForm"
                    htmlFor="check"
                    style={{ fontSize: "1rem", fontWeight: "600" }}
                  >
                    Hacé click aquí si sos una Agencia de Turismo, un Sindicato
                    o Freelance
                  </label>
                </div>

                {mostrarInputsOcultos && (
                  <div>
                    <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label className="labelForm" htmlFor="tipoCliente">
                        Tipo de Cliente
                      </label>
                      <select
                        className="form-control"
                        value={usuario.tipoCliente}
                        name="tipoCliente"
                        onChange={handleTipoClienteChange}
                      >
                        <option value="">Tipo Cliente</option>
                        {/*<option value="IND">Individual</option>*/}
                        <option value="AGE">Agencia</option>
                        <option value="SIN">Sindicato/Mutual</option>
                        <option value="FRE">Freelance</option>
                      </select>
                    </div>

                    {/*DATOS DE LA AGENCIA*/}
                    {usuario.tipoCliente !== "FRE" && (
                      <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                        <label className="labelForm" htmlFor="nombreAgencia">
                          Nombre{" "}
                          {usuario.tipoCliente === "SIN"
                            ? "Sindicato/Mutual"
                            : "Agencia"}{" "}
                          *
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="nombreAgencia"
                          placeholder="Nombre"
                          onChange={handleDatosClienteChange}
                          value={usuario.cliente.nombreAgencia}
                        />
                      </div>
                    )}
                    {usuario.tipoCliente === "AGE" && (
                      <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                        <label className="labelForm" htmlFor="legajo">
                          N° Legajo *
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="legajo"
                          placeholder="Legajo"
                          onChange={handleDatosClienteChange}
                          value={usuario.cliente.legajo}
                        />
                      </div>
                    )}

                    <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label className="labelForm" htmlFor="categoriaIVA">
                        Categoria de IVA *
                      </label>
                      <select
                        className="form-control"
                        name="categoriaIVA"
                        onChange={handleCategoriaIvaChange}
                        value={usuario.cliente.categoriaIVA.codigo}
                      >
                        <option value="SIN">Categorias de IVA</option>
                        {categoriasIVA.map((categoria) => {
                          return (
                            <option key={categoria.id} value={categoria.codigo}>
                              {categoria.denominacion}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label className="labelForm" htmlFor="tipoDocumento">
                        Tipo de Documento *
                      </label>
                      <select
                        className="form-control"
                        name="tipoDocumento"
                        onChange={handleTipoDocumentoChange}
                        value={usuario.cliente.tipoDocumento.sigla}
                        disabled={isDisabled}
                      >
                        <option disabled value="">
                          Tipo Documento
                        </option>
                        {tiposDocumento.map((tipoDeDocumento) => {
                          return (
                            <option
                              key={tipoDeDocumento.idTipoDocumento}
                              value={tipoDeDocumento.sigla}
                            >
                              {tipoDeDocumento.denominacion}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label className="labelForm" htmlFor="numeroDocumento">
                        N° {usuario.cliente.tipoDocumento.sigla} * (Sin guiones
                        ni puntos)
                      </label>
                      <input
                        className="form-control"
                        type="number"
                        name="numeroDocumento"
                        placeholder="Número"
                        onChange={handleDatosClienteChange}
                      />
                    </div>
                  </div>
                )}

                <div className="contenedorLinkInicio col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                  <input
                    className="botonInicio"
                    type="submit"
                    value="Registrarse"
                    onClick={handleRegistrarClick}
                  />

                  <div className="options">
                    <Link className="float-left" to={"/login"}>
                      Login
                    </Link>
                    <Link className="float-right" to={"/recuperar-password"}>
                      ¿Olvid&oacute; su contrase&ntilde;a?
                    </Link>
                  </div>
                </div>
              </form>
            </div>
            <div className="listado">
              <Link to="/">Volver al inicio</Link>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default Registrar;



// WEBPACK FOOTER //
// ./src/components/Registrar/index.js